"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAppWrapper = void 0;
var React = require("react");
var AdminAppWrapper = function (_a) {
    var element = _a.element, children = _a.children;
    var _b = __read(React.useState(element.classList.contains("active")), 2), mount = _b[0], setMount = _b[1];
    React.useEffect(function () {
        var attrObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mu) {
                if (mu.type !== "attributes" && mu.attributeName !== "class")
                    return;
                setMount(element.classList.contains("active"));
            });
        });
        attrObserver.observe(element, { attributes: true });
    }, [element]);
    return mount && React.createElement(React.Fragment, null, children);
};
exports.AdminAppWrapper = AdminAppWrapper;
